import { Link } from 'react-router-dom'
import { SENSORES_CHANNELS_URL, SENSORES_STORE_URL } from '@versports/ui'

/**
 * Apps nativas de VerSports que se instalan desde la Meta Horizon Store
 * (sólo administradores). Hoy: VerSports Sensores, en el canal Alpha privado:
 * la ficha sólo se abre para cuentas Meta invitadas a ese canal.
 */
export { SENSORES_APP_ID, SENSORES_STORE_URL, SENSORES_CHANNELS_URL } from '@versports/ui'

export function AdminApps() {
  return (
    <div className="mx-auto max-w-3xl">
      <header className="mb-lg">
        <h1 className="text-2xl font-bold">Apps</h1>
        <p className="mt-sm text-text-secondary">Apps nativas de VerSports que se instalan en el visor desde la Meta Horizon Store.</p>
      </header>

      <article className="card p-lg">
        <div className="flex flex-wrap items-baseline justify-between gap-sm">
          <h2 className="font-display text-xl font-bold normal-case tracking-tight">VerSports Sensores</h2>
          <span className="tag">Alpha privado</span>
        </div>
        <p className="mt-sm text-text-secondary">
          Conecta el Polar H10 a VerSports en el navegador del visor.
          Setup completo en <Link className="underline" to="/admin/setup">Setup</Link>.
        </p>

        <a className="btn-primary mt-lg inline-block text-center" href={SENSORES_STORE_URL} target="_blank" rel="noopener noreferrer">
          Instalar desde la Meta Horizon Store
        </a>

        <section className="mt-lg space-y-sm text-sm text-text-secondary" aria-label="Cómo instalar">
          <h3 className="font-semibold text-text-primary">Cómo instalar</h3>
          <ol className="list-decimal space-y-xs pl-lg">
            <li>La cuenta Meta del visor tiene que estar <strong>invitada al canal Alpha</strong> y haber aceptado la invitación que llega por mail.</li>
            <li>Abrí este link en el navegador del visor, o en la app Meta Horizon del celular con la misma cuenta, y tocá Instalar.</li>
            <li>La app queda en la biblioteca del visor y se actualiza sola.</li>
          </ol>
          <p>Sin invitación, la ficha de la Store no se abre. Las invitaciones se manejan en los <a className="underline" href={SENSORES_CHANNELS_URL} target="_blank" rel="noopener noreferrer">canales de la app</a> (organización HumaiTech en Meta).</p>
        </section>
      </article>
    </div>
  )
}
